import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import PageShell from "../../components/PageShell";
import OpdReport from "../inPatientDetail/OpdReports";
import {
  PAGE_TABS_BAR_SX,
  PAGE_TAB_LIST_PROPS,
  TAB_PANEL_SX,
} from "../../utils/pageLayoutStyles";

const OpdDashboard = ({ patientId: propPatientId }) => {
  const { patientId: paramPatientId } = useParams();
  const patientId = propPatientId ?? paramPatientId;
  const location = useLocation();
  const { tab: incomingTab, patient: incomingPatientInfo } = location?.state || {};
  const [selectedTab, setSelectedTab] = useState(incomingTab === "2" ? "opd" : "opd");

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <PageShell title="PATIENTS">
      <TabContext value={selectedTab}>
        <Box sx={PAGE_TABS_BAR_SX}>
          <TabList {...PAGE_TAB_LIST_PROPS} onChange={handleChange}>
            <Tab label="Out Patients" value="opd" />
          </TabList>
        </Box>
        <TabPanel value="opd" sx={TAB_PANEL_SX}>
          <OpdReport patientId={patientId} initialPatientInfo={incomingPatientInfo || null} />
        </TabPanel>
      </TabContext>
    </PageShell>
  );
};

export default OpdDashboard;
